class ProductGridContainer extends HTMLElement {
	constructor() {
		super()
		this.selectors = {
			container: '#ProductGridContainer',
			paginate: '[data-paginate]',
			btnLoadmore: '[data-load-more]',
			productGrid: '[data-products-grid]',
			columnSelector: '.column-switcher button',
		}
	}

	connectedCallback() {
		this.init()
	}

	init() {
		this.container = this.closest(this.selectors.container)
		this.sectionId = this.dataset.sectionId
		this.domNodes = queryDomNodes(this.selectors, this)
		this.infiniteLoadingObserver = null
		this.currentPage = 1
		this.save_key = 'foxtheme:grid-columns'

		this.initLoadMore()
		this.columnSwitcher()
	}

	initLoadMore() {
		const {paginate} = this.domNodes
		if (!paginate) return
		this.paginateType = paginate.dataset.paginate
		this.totalPages = Number(paginate.dataset.totalPages)

		if (this.paginateType === 'number' || this.totalPages <= 1) return

		const { btnLoadmore } = this.domNodes
		addEventDelegate({
			selector: this.selectors.btnLoadmore,
			handler: e => {
				e.preventDefault()
				this.loadMoreProducts()
			}
		})

		if (this.paginateType === 'infinite') {
			this.infiniteLoadingObserver = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.intersectionRatio === 1) this.loadMoreProducts()
				});
			}, { threshold: 1 });

			this.infiniteLoadingObserver.observe(btnLoadmore)
		}
	}

	//TODO: Re-check after filter
	loadMoreProducts() {
		const productGrid = document.querySelector(this.selectors.productGrid)
		const btnLoadmore = document.querySelector(this.selectors.btnLoadmore)
		const nextPage = this.currentPage + 1
		if (nextPage > this.totalPages) return

		this.toggleLoading(true, btnLoadmore)
		fetchSection(this.sectionId, { fromCache: true, params: { page: nextPage } })
			.then(html => {
				const productNodes = html.querySelectorAll('[data-products-grid] .f-column')
				productNodes.forEach(prodNode => productGrid.appendChild(prodNode))
			})
			.catch(err => console.error(`Failed to load more products.`, err))
			.finally(() => {
				this.toggleLoading(false, btnLoadmore)
				this.currentPage = nextPage
				if (nextPage >= this.totalPages) {
					btnLoadmore.parentNode.remove()
					if (this.infiniteLoadingObserver) {
						this.infiniteLoadingObserver.unobserve(btnLoadmore)
					}
				}
			})
	}

	toggleLoading(loading, btnLoadmore) {
		if (btnLoadmore) {
			const method = loading ? 'add' : 'remove'
			btnLoadmore.classList[method]('btn--loading')
		}
	}

	columnSwitcher() {
		const data = localStorage.getItem(this.save_key)
		if (!window.FoxThemeSettings.designMode && '1,2'.includes(data)) this.setColumn(data)

		addEventDelegate({
			selector: this.selectors.columnSelector,
			context: this,
			handler: (e, target) => {
				e.preventDefault()
				const {column} = target.dataset
				this.setColumn(column)
			}
		})

	}

	setColumn(column) {
		const productGrid = document.querySelector(this.selectors.productGrid)
		if (!productGrid) return
		const target = this.querySelector('.column-switcher button[data-column="'+ column +'"]')
		const selected = this.querySelector('.column-switcher button[aria-selected="true"]')
		if (selected) {
			selected.removeAttribute('aria-selected')
		}
		target.setAttribute('aria-selected', true)

		if (column === '2') {
			productGrid.classList.add('f-grid-2-cols');
			productGrid.classList.remove('f-grid-1-cols');
		} else {
			productGrid.classList.remove('f-grid-2-cols');
			productGrid.classList.add('f-grid-1-cols');
		}

		localStorage.setItem(this.save_key, column)
	}
}

customElements.define('product-grid-container', ProductGridContainer)

/* === Move sold-out products to the end of #product-grid ===
   - Looks for product columns with selector ".f-column"
   - Detects sold-out badge using ".f-badge.f-badge--soldout"
   - Reorders on initial load and when new nodes are added (MutationObserver)
   - Lightweight debounce to avoid thrash
*/

(function () {
  const SOLD_OUT_SELECTOR = ".f-badge.f-badge--soldout"; // sold-out badge inside product card
  const PRODUCT_COLUMN_SELECTOR = ".f-column"; // product wrapper (each product tile)
  const PRODUCT_GRID_ID = "#product-grid"; // container id used in your Liquid

  // Debounced reorder function
  function debounce(fn, wait = 120) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function reorderSoldOut() {
    const productGrid = document.querySelector(PRODUCT_GRID_ID);
    if (!productGrid) return;

    // Get direct product columns (preserve only those that are real elements)
    const products = Array.from(productGrid.querySelectorAll(PRODUCT_COLUMN_SELECTOR)).filter(Boolean);
    if (!products.length) return;

    const inStock = [];
    const outOfStock = [];

    products.forEach((product) => {
      if (product.querySelector(SOLD_OUT_SELECTOR)) {
        outOfStock.push(product);
        product.classList.add("out-of-stock");
      } else {
        inStock.push(product);
        product.classList.remove("out-of-stock");
      }
    });

    // If there are no out-of-stock items, nothing to do
    if (outOfStock.length === 0) return;

    // Build fragment and replace children (minimize reflow)
    const frag = document.createDocumentFragment();
    inStock.forEach(p => frag.appendChild(p));
    outOfStock.forEach(p => frag.appendChild(p));

    // Only replace if order would change (cheap check)
    const firstOut = outOfStock[0];
    if (firstOut && productGrid.lastElementChild !== firstOut) {
      // Clear and append
      productGrid.innerHTML = "";
      productGrid.appendChild(frag);
    }
  }

  // Debounced wrapper for observers/events
  const runReorder = debounce(reorderSoldOut, 120);

  // Run on initial load (DOM ready)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runReorder);
  } else {
    runReorder();
  }

  // MutationObserver: observe additions to #product-grid (load-more / infinite)
  function startObserver() {
    const grid = document.querySelector(PRODUCT_GRID_ID);
    if (!grid) return null;

    const observer = new MutationObserver((mutations) => {
      let added = false;
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) {
          added = true;
          break;
        }
      }
      if (added) runReorder();
    });

    observer.observe(grid, { childList: true, subtree: false });
    return observer;
  }

  // Try to start observer now, or when grid appears later
  let observer = startObserver();
  if (!observer) {
    // If grid not present yet, watch body for when it appears, then attach observer
    const bodyObserver = new MutationObserver((mutations, obs) => {
      if (document.querySelector(PRODUCT_GRID_ID)) {
        obs.disconnect();
        observer = startObserver();
        runReorder();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Also listen for common custom events if your theme dispatches them (safe no-op)
  window.addEventListener("products:loaded", runReorder, { passive: true });
  window.addEventListener("collection:updated", runReorder, { passive: true });
})();
